import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { api } from '../lib/api';

function safeDestination(value: string): string {
  return value.startsWith('/') && !value.startsWith('//') ? value : '/dashboard';
}

export default function AuthCallback() {
  const nav = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const code = fragment.get('code') ?? '';
    // Remove the one-time handoff before any later navigation or user action.
    window.history.replaceState(window.history.state, '', '/auth/callback');
    if (!code) {
      setError('This sign-in link is incomplete. Please start again.');
      return;
    }
    void api.consumeOAuth(code)
      .then((result) => nav(safeDestination(result.returnTo), { replace: true }))
      .catch((reason) => setError(reason instanceof Error ? reason.message : 'Sign-in failed'));
  }, [nav]);

  return (
    <>
      <Navbar />
      <main className="page auth-wrap">
        <section className="auth-card auth-callback" aria-live="polite">
          {error ? (
            <>
              <h1>Couldn’t finish signing in</h1>
              <p className="form-error" role="alert">{error}</p>
              <Link className="btn btn-primary" to="/login">Back to sign in</Link>
            </>
          ) : (
            <>
              <span className="auth-spinner" aria-hidden="true" />
              <h1>Finishing sign-in…</h1>
              <p>Securely connecting your account.</p>
            </>
          )}
        </section>
      </main>
    </>
  );
}
